import { getChannelAPIPath } from '@treasury/core/http';

CountriesService.$inject = ['$resource', '$q'];

export default function CountriesService($resource, $q) {
    const resourceUrl = `${getChannelAPIPath()}countries/`;
    return {
        getAll,
    };

    function getAll() {
        return $resource(resourceUrl).query().$promise;
    }
}
